/**
 * # `FeedsApiMixin.js`
 *
 * A mixin wrapper around `feeds.js`, so you can use those functions as methods in components.
 *
 * To add something new, first write a pure wrapper function in `feeds.js`, then call it in a method here.
 */

import * as FEEDS_LIB from "Lib/feeds";

export default {
  data() {
    return {
      data_uri: FEEDS_LIB.FEEDS_DATA_URI,
      can_import_feed: true,
    };
  },
  beforeMount() {
    this.can_import_feed = this.permissionsCanAccessFeature('feed_importer')
      && this.permissionsCanDoAction('api.feed-importer.import');

    /**
     * From Lib/feeds
     */
    Object.entries(FEEDS_LIB).filter(entry => typeof entry[1] === 'function').forEach(([name, fn]) => {
      this[name] = fn.bind(this); // using .bind to pass 'this' context
    });
  },
  methods: {

  },
};
